import Image from 'next/image';

import { images } from '~/landing/assets';

type LogoGermenProps = {
  onClick?: () => void;
};

export const LogoGermen = ({ onClick }: LogoGermenProps) => {
  return (
    <button className="flex items-center gap-2" onClick={onClick}>
      <Image
        alt="Germen logo icon"
        height={24}
        src={images.germen['logo-text']}
        width={130}
      />
    </button>
  );
};
